import { Directive, ViewContainerRef, TemplateRef, Input, OnInit, OnChanges } from '@angular/core';

@Directive({
  selector: '[ngRepeat]'
})
export class NgRepeatDirective implements OnInit, OnChanges {

  @Input('ngRepeatFrom') repeatFrom ? = 0;
  @Input('ngRepeatWithFactor') repeatFactor ? = 1;
  @Input('ngRepeatUntil') repeatUntil: number;

  context = {};
  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>
  ) { }

  ngOnInit() {
    this.viewContainerRef.clear();
    for (let i = this.repeatFrom; i < this.repeatUntil ; i += this.repeatFactor) {
      this.viewContainerRef.createEmbeddedView(this.templateRef, {
        index: i
      });
    }
  }

  ngOnChanges() {
    this.ngOnInit();
  }
}
